export default __webpack_public_path__ + "static/media/Additive Manufacturing.52ff6d77.pdf";